import React from "react";

export const PdfFileIcon = ({ size = 18, color = "currentColor" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      stroke={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.49731 16.498H2.49731C2.2321 16.498 1.97774 16.3927 1.79021 16.2052C1.60267 16.0176 1.49731 15.7633 1.49731 15.498V2.49805C1.49731 2.23283 1.60267 1.97848 1.79021 1.79094C1.97774 1.6034 2.2321 1.49805 2.49731 1.49805H9.58331C9.71471 1.49807 9.8448 1.524 9.96617 1.57433C10.0875 1.62466 10.1978 1.69842 10.2906 1.79138L14.2046 5.70538C14.2975 5.79828 14.3711 5.90857 14.4213 6.02993C14.4716 6.1513 14.4974 6.28137 14.4973 6.41271V9.49805"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4973 6.49805H10.4973C10.2321 6.49805 9.97774 6.39269 9.79021 6.20515C9.60267 6.01762 9.49731 5.76326 9.49731 5.49805V1.49805"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.49731 16.498V11.498"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.49731 11.498H6.99998C7.39781 11.498 7.77934 11.6561 8.06064 11.9374C8.34195 12.2187 8.49998 12.6002 8.49998 12.998C8.49998 13.3959 8.34195 13.7774 8.06064 14.0587C7.77934 14.34 7.39781 14.498 6.99998 14.498H6.49998"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4973 16.498C11.0277 16.498 11.5365 16.2873 11.9115 15.9123C12.2866 15.5372 12.4973 15.0285 12.4973 14.498V13.498C12.4973 12.9676 12.2866 12.4589 11.9115 12.0838C11.5365 11.7088 11.0277 11.498 10.4973 11.498V16.498Z"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4973 16.498V12.498C14.4973 12.2328 14.6027 11.9785 14.7902 11.7909C14.9777 11.6034 15.2321 11.498 15.4973 11.498H16.4973"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4973 14.498H15.9973"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
